import { Routes } from '@angular/router';
import { ManagementLayout } from '@tsin-shared/layouts/management/management.layout';
import { UserLayout } from '@tsin-shared/layouts/user/user.layout';
import { CallbackComponent } from './pages/account/callback/callback.component';
import { localeGuard } from '@tsin-core/guards/locale.guard';

export const routes: Routes = [
  // ── English routes (existing, locale defaults to 'en') ────────────────────
  { path: '', redirectTo: '/account/validate-login', pathMatch: 'full' },
  { path: 'auth/callback', component: CallbackComponent },
  { path: 'PRA-NB', loadChildren: () => import('./pages/pra-nb/pra-nb.routes') },
  { path: 'management', component: ManagementLayout, data: { preload: true }, loadChildren: () => import('./pages/management/management') },
  { path: 'account', component: UserLayout, data: { preload: true }, loadChildren: () => import('./pages/account/account.routes') },
  { path: 'staff', component: UserLayout, data: { preload: true }, loadChildren: () => import('./pages/staff/staff.routes') },
  { path: 'user', component: UserLayout, data: { preload: true }, loadChildren: () => import('./pages/user/user.routes') },
  { path: 'references', data: { preload: false }, loadChildren: () => import('./pages/references/references.routes') },

  // ── French routes (/fr prefix) ────────────────────────────────────────────
  // Same lazy-loaded modules — locale is set to 'fr' by the localeGuard,
  // which loads assets/i18n/fr.json and sets <html lang="fr">.
  {
    path: 'fr',
    canActivate: [localeGuard],
    data: { locale: 'fr', preload: false },
    children: [
      { path: '', redirectTo: 'account/validate-login', pathMatch: 'full' },
      { path: 'auth/callback', component: CallbackComponent },
      { path: 'PRA-NB', loadChildren: () => import('./pages/pra-nb/pra-nb.routes') },
      {
        path: 'management',
        component: ManagementLayout,
        data: { preload: true },
        loadChildren: () => import('./pages/management/management'),
      },
      {
        path: 'account',
        component: UserLayout,
        loadChildren: () => import('./pages/account/account.routes'),
      },
      {
        path: 'staff',
        component: UserLayout,
        data: { preload: true },
        loadChildren: () => import('./pages/staff/staff.routes'),
      },
      {
        path: 'user',
        component: UserLayout,
        loadChildren: () => import('./pages/user/user.routes'),
      },
      {
        path: 'references',
        loadChildren: () => import('./pages/references/references.routes'),
      },
      { path: '**', redirectTo: 'account/validate-login' },
    ],
  },

  { path: '**', redirectTo: '/account/validate-login' },
];
